import React from 'react';

export interface Column<Row> {
  key: string;
  header: string;
  className?: string;
  render: (row: Row, index: number) => React.ReactNode;
}

export interface ChangesTableProps<Row> {
  columns: Column<Row>[];
  rows: Row[];
  emptyMessage?: string;
  className?: string;
}

function ChangesTable<Row>({ columns, rows, emptyMessage = 'No items found.', className = '' }: ChangesTableProps<Row>) {
  if (!rows || rows.length === 0) {
    return (
      <div className={`text-center p-8 text-cm-text-muted ${className}`}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="w-full text-sm text-left text-cm-text-muted">
        <thead className="text-xs text-cm-text-primary uppercase bg-cm-bg-elevated">
          <tr>
            {columns.map(col => (
              <th key={col.key} scope="col" className={`px-6 py-3 ${col.className ?? ''}`}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="bg-cm-bg-surface border-b hover:bg-cm-bg-elevated group">
              {columns.map(col => (
                <td key={col.key} className={`px-6 py-4 ${col.className ?? ''}`}>
                  {col.render(row, index)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ChangesTable;
